import { CatalogItemType } from 'models'
import { sortOptionsType } from 'shared/pipes'

export const sorByOptions: sortOptionsType[] = [
  sortOptionsType.Position,
  sortOptionsType.New,
  sortOptionsType.Old,
  sortOptionsType.NameDesk,
  sortOptionsType.NameAsk,
]

export const formatsOptions = [
  {
    value: `${CatalogItemType.Film}`,
    title: 'Фильм',
  },
  {
    value: `${CatalogItemType.Serial}`,
    title: 'Сериал',
  },
  {
    value: `${CatalogItemType.Show}`,
    title: 'Шоу',
  },
  {
    value: `${CatalogItemType.KinoStories}`,
    title: 'КиноStories',
  },
  {
    value: `${CatalogItemType.Documentary}`,
    title: 'Документальный',
  },
  {
    value: `${CatalogItemType.FeatureFilm}`,
    title: 'Художественный',
  },
]

export const emptyGenres = [[], []]
